import { Box, styled, Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';

const CustomInputBox = styled(Box)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "5px",
  gap: "10px",
  background: "#F6F6F6",
  height: "auto",
  border: " 1px solid #E1E1E6",
  borderRadius: "4px",
  paddingRight: 10,
  paddingLeft: 10,
});

const CustomInputField = styled("input")({
  width: "100%",
  height: "25px",
  backgroundColor: "transparent",
  border: "none",
  padding: 0,
  outline: "none",
});

const SubTitle = styled(Typography)(({ theme })=>({
  fontFamily: theme.typography.fontFamily,
  fontStyle: "normal",
  marginTop: 10,
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "140%",
  display: "flex",
  alignItems: "center",
  textAlign: "center",
  letterSpacing: "0.015em",
  color:"#1A1824",
}));


const CustomInput = ({
  label,
  ...rest
}) => {
  return (
    <>
      <SubTitle>{label}</SubTitle>
      <CustomInputBox>
        <CustomInputField
          type={"text"}
          {...rest}
        />
        <i class="fa fa-circle-check"></i>
      </CustomInputBox>
    </>
  );
};

export default CustomInput;
